// extracted by mini-css-extract-plugin
export default {"label":"ayfYbMCnvtqXCpi06uv0","positionStatic":"IPcMxelXll2yo22_9jgW","inDropDown":"taXskPqlH0jF0eihV1V4","inRow":"knu33PfWXZPa4V13U7ig"};